import type { ParsedSkin } from "../lib/spineParser";

/** 关联模版最小结构（避免与 configStore 循环依赖） */
export type RelatedSkinLookup = {
  parsedSkins: ParsedSkin[];
  config?: { skus?: Record<string, any> };
};

function syntheticSkinFromSku(skinName: string, sku: any): ParsedSkin {
  return {
    name: skinName,
    skuId: sku.id,
    category: sku.category || "static",
    slots: [],
    attachmentCount: 0,
  };
}

/**
 * 解析「当前可选的」皮肤元数据：Spine JSON 中的 skin + 仅存在于 SKU 的占位名（如静态层 skinName: static）
 */
export function resolveParsedSkin(
  skinName: string,
  templateConfig: { skus?: Record<string, any> } | null | undefined,
  parsedSkins: ParsedSkin[],
  loadedRelatedTemplates: RelatedSkinLookup[] | undefined,
): ParsedSkin | null {
  let skin = parsedSkins.find((s) => s.name === skinName);
  if (skin) return skin;

  if (loadedRelatedTemplates) {
    for (const rel of loadedRelatedTemplates) {
      skin = rel.parsedSkins.find((s) => s.name === skinName);
      if (skin) return skin;
    }
  }

  const mainSkus = templateConfig?.skus || {};
  for (const sku of Object.values(mainSkus) as any[]) {
    if (sku?.skinName === skinName) {
      return syntheticSkinFromSku(skinName, sku);
    }
  }

  if (loadedRelatedTemplates) {
    for (const rel of loadedRelatedTemplates) {
      const relSkus = rel.config?.skus || {};
      for (const sku of Object.values(relSkus) as any[]) {
        if (sku?.skinName === skinName) {
          return syntheticSkinFromSku(skinName, sku);
        }
      }
    }
  }

  return null;
}
